import Head from 'next/head'
import type { FunctionComponent } from 'react'
import type { SeoResult } from '../app/data/content/OgSchemaFragment'

const siteTitles = {
	'cs-jogaOnline': 'Jóga-Online',
	'en-jogaOnline': 'Jóga-Online',
	'cs-plneVedomi': 'Plné Vědomí',
	'en-plneVedomi': 'Mindfulness',
}
interface SeoProps {
	canonicalUrl?: string
	seo: SeoResult
	siteCode: string
}

export const Seo: FunctionComponent<SeoProps> = ({
	canonicalUrl,
	seo: { title, description, ogTitle, ogDescription, ogImage },
	siteCode,
}) => {
	const siteTitle = siteTitles[siteCode as keyof typeof siteTitles]
	return (
		<Head>
			<title>{title ? `${title} | ${siteTitle}` : siteTitle}</title>
			{description && <meta name="description" content={description} />}
			<meta property="og:locale" content="cs_CZ" />
			{ogTitle && <meta property="og:title" content={ogTitle} />}
			{ogDescription && <meta property="og:description" content={ogDescription} />}
			{ogImage && (
				<>
					<meta property="og:image" content={ogImage.url} />
					{ogImage.alt && <meta property="og:image:alt" content={ogImage.alt} />}
					{ogImage.width && <meta property="og:image:width" content={`${ogImage.width}`} />}
					{ogImage.height && <meta property="og:image:height" content={`${ogImage.height}`} />}
				</>
			)}
			{canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
		</Head>
	)
}
